import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const track = (name, props = {}) => {
  if (typeof window !== "undefined" && window.clarity) {
    window.clarity("event", name, props);
  }
};

const WhatsNewSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/feature-announcements.json`)
      .then((res) => res.json())
      .then((json) => setData(json))
      .catch((err) => console.error("Failed to load feature announcements:", err));
  }, []);

  if (!data?.items?.length) return null;

  const visibleItems = data.items.filter((item) => item.visible);

  if (!visibleItems.length) return null;

  return (
    <section className="mt-14 max-w-7xl mx-auto">
      <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
        <div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900">
            {data.sectionTitle || "What’s New in myBOQ"}
          </h2>
          <p className="mt-2 text-gray-600 text-sm sm:text-base">
            {data.sectionSubtitle || "Latest product launches and improvements."}
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {visibleItems.map((item) => (
          <div
            key={item.id}
            className="rounded-2xl border border-gray-200 bg-white shadow-sm p-5 hover:shadow-md transition"
          >
            <div className="inline-flex items-center px-2.5 py-1 rounded-full bg-orange-50 text-orange-700 text-xs font-semibold border border-orange-100">
              {item.tag || "New"}
            </div>

            <h3 className="mt-3 text-base font-bold text-gray-900">
              {item.title}
            </h3>

            <p className="mt-2 text-sm text-gray-600 leading-relaxed">
              {item.description}
            </p>

            {item.link && (
              <Link
                to={item.link}
                className="inline-flex mt-4 text-sm font-semibold text-orange-600 hover:underline"
                onClick={() =>
                  track("whats_new_click", {
                    id: item.id,
                    title: item.title,
                    link: item.link,
                  })
                }
              >
                Explore more →
              </Link>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatsNewSection;